import { z } from 'zod/v3';
import {
  ActionResult,
  ApplicableContext,
  BaseAction,
  ExecuteContext,
} from '@cotera/client/v0/actions/framework';

const emptyParamsSchema = z.object({});

/**
 * Shared base for the workflow editor's canvas actions (empty payload).
 *
 * Most render as a toolbar button; the clipboard ones are keyboard and command
 * palette only. Either way they act on whatever the canvas has selected, which
 * is why none of them take a payload.
 */
export abstract class WorkflowEditorToolbarActionBase<
  Errors extends { t: string }[] = { t: string }[]
> extends BaseAction<Record<string, never>, Errors> {
  inputSchema = emptyParamsSchema;
  description?: string;

  abstract override applicable(context: ApplicableContext): boolean;

  abstract override execute(
    payload: Record<string, never>,
    context: ExecuteContext
  ): Promise<ActionResult<Errors>>;
}
